import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';
import IInitialDetails from '@sunbit-dev/common/models/cardApply/IInitialDetails';
import { replace } from 'connected-react-router';
import qs from 'qs';
import CommonThunk from '../models/CommonThunk';
import sunbitApi from '../services/sunbitApi';
import DocumentTypes, { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import { loadApplicationDocumentSuccess } from './applicationDocumentsActions';
import URLS from '../constants/urls'
import { showWelcomerModal } from '../actions/welcomerPopupActions';

export enum ActionTypes {
  getInitialDetails = 'getInitialDetails',
}

const getInitialDetailsPending = () => ({
  type: ActionTypes.getInitialDetails,
  status: ActionStatus.Pending
});

const getInitialDetailsSuccess = (initialDetails: IInitialDetails) => ({
  type: ActionTypes.getInitialDetails,
  status: ActionStatus.Success,
  ...initialDetails
});

const getInitialDetailsError = (error: ApplicationError) => ({
  type: ActionTypes.getInitialDetails,
  status: ActionStatus.Failure,
  error
});

export const getInitialDetailsThunk = (): CommonThunk => {
  return async (dispatch) => {
    if (!sunbitApi.isTokenReady()) {
      return
    }
    dispatch(getInitialDetailsPending());
    try {

      // Pre-Initial login in case pendingApplicationId exists
      if (sunbitApi.pendingApplicationId){
        const applicationIdResponse = await sunbitApi.generateAppplicationId();
        sunbitApi.setApplicationId(applicationIdResponse.cardApplicationId);
        sunbitApi.setInitialToken(applicationIdResponse.token);
      }

      const results = await Promise.all([
        sunbitApi.getInitialDetails(),
        sunbitApi.getStaticDocument(DocumentTypes[DocumentTypesTypes.CardApplicationSolicitationDisclosures])
      ]);

      const initialDetails = results[0];
      const documentResponse = results[1];
      const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      const referringPartner = queryParams.referringPartner;
      dispatch(getInitialDetailsSuccess(initialDetails));
      dispatch(loadApplicationDocumentSuccess(documentResponse, DocumentTypesTypes.CardApplicationSolicitationDisclosures));

      if (!initialDetails.initial) {
        dispatch(replace(URLS.applicationExistingApplication));
      } else {
        if (referringPartner){
          dispatch(showWelcomerModal());
        }
      }
    } catch (error) {
      dispatch(getInitialDetailsError(error as ApplicationError));
    }
  }
}

export type Actions = ReturnType<typeof getInitialDetailsPending> | ReturnType<typeof getInitialDetailsSuccess> | ReturnType<typeof getInitialDetailsError>;
